import React, { FC } from 'react';
import styled from 'styled-components';
import { useWindowWidth } from 'utils/useWindowWidth';

import InfoElements, { InfoElementType } from 'components/common/Card/common/V2CardBodyDefault/InfoElements';
import ModificationsContainer, { ModificationsProps } from 'components/common/Card/common/V2CardBodyDefault/ModificationsContainer/ModificationsContainer';
import OrganizationContainer, { OrganizationProps } from 'components/common/Card/common/V2CardBodyDefault/OrganizationContainer';
import PredicetdPriceAndCalculationContainer from 'components/common/Card/common/V2CardBodyDefault/PredictedPriceAndCalculationContainer';
import { RatingProps } from 'components/common/Card/common/V2CardBodyDefault/RatingContainer';
import V2InteractiveIconsWrapper, {
    InteractiveIconsWrapperProperties
} from 'components/common/Card/common/V2InteractiveIconsWrapper/V2InteractiveIconsWrapper';

const IconsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: end;
`;

const OrganizationWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;

    @media (max-width: 586px) {
        flex-direction: column;
    }
`;

const Wrapper = styled.div`
    grid-area: bottom;
`;

const PaddingContainer = styled.div`
    margin: 10px 0;
`;

export interface OrganizationAndRatingProps {
    organizationContainer: OrganizationProps;
    ratingContainer?: RatingProps;
}

export type BottomProps = {
    infoElements?: InfoElementType[];
    modifications?: ModificationsProps;
    organizationAndRating?: OrganizationAndRatingProps;
    calculationValue?: string;
    predictedPrice?: string;
    hasPredictionRole?: boolean;
    hasCalculationRole?: boolean;
} & InteractiveIconsWrapperProperties;

const Bottom: FC<BottomProps> = ({
    infoElements,
    modifications,
    userDetails,
    isNotInteractive,
    notInteractiveElements,
    interactiveElements,
    showMessages,
    setShowMessages,
    openOfferTab,
    organizationAndRating,
    calculationValue,
    predictedPrice,
    hasCalculationRole,
    hasPredictionRole
}) => {
    const width = useWindowWidth();

    return (
        <Wrapper>
            <IconsWrapper>
                {width < 490 && <PredicetdPriceAndCalculationContainer calculationValue={calculationValue} predictedPrice={predictedPrice} openOfferTab={openOfferTab} hasCalculationRole={hasCalculationRole} hasPredictionRole={hasPredictionRole}/>}
                {width < 490 && (calculationValue || predictedPrice) && <PaddingContainer/>}
                {width < 490 && infoElements && infoElements.length > 0 &&
                    <InfoElements infoElements={infoElements}/>
                }
                {width < 489 && modifications && <ModificationsContainer modifications={modifications}/>}

                {width < 991 && !modifications && <PaddingContainer/>}
                {organizationAndRating?.organizationContainer.isReserved &&
                    <OrganizationWrapper><OrganizationContainer organizationContainer={organizationAndRating.organizationContainer}/></OrganizationWrapper>}
                <V2InteractiveIconsWrapper
                    userDetails={userDetails}
                    isNotInteractive={isNotInteractive}
                    notInteractiveElements={notInteractiveElements}
                    interactiveElements={interactiveElements}
                    showMessages={showMessages}
                    setShowMessages={setShowMessages}
                    openOfferTab={openOfferTab}
                />
            </IconsWrapper>
        </Wrapper>
    );
};

export default Bottom;
